import styled from "styled-components";

export const Group = styled.div`
    margin-bottom: 20px;
`;

export const Label = styled.span`
    font-weight: bold;
`;